import React, { useCallback, useRef } from 'react';

import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';

const videoConstraints = {
    width: 400,
    height: 400,
    facingMode: "user"
};


export const WebcamCapture = ({ openCamera, handleUpload }) => {
    const [facingMode, setFacingMode] = React.useState('front');

    // const capture = useCallback(() => {
    //     const imageSrc = webcamRef.current.getScreenshot();
    //     fetch(imageSrc)
    //         .then(res => res.blob())
    //         .then((blob) => {
    //             let imageurl = URL.createObjectURL(blob);

    //             let name = Math.random() + "." + blob.type.split("/")[1];
    //             const myFile = new File([blob], name, { type: blob.type });
    //             // let fileObject = {
    //             //     name: myFile.name,
    //             //     lastModified: myFile.lastModified,
    //             //     size: myFile.size,
    //             //     type: myFile.type,
    //             //     path: imageurl,
    //             // }
    //             // dispatch(scanface(JSON.stringify(fileObject)))
    //             handleUpload(myFile, imageurl)
    //             openCamera(false);
    //         })
    // }, [webcamRef]);

    function handleTakePhotoAnimationDone(dataUri) {
        console.log('takePhoto');
        // setDataUri(dataUri);
        let imageSrc = dataUri;
        // handleUpload(myFile, imageurl)
        fetch(imageSrc)
            .then(res => res.blob())
            .then((blob) => {
                let imageurl = URL.createObjectURL(blob);

                let name = Math.random() + "." + blob.type.split("/")[1];
                const myFile = new File([blob], name, { type: blob.type });
                // let fileObject = {
                //     name: myFile.name,
                //     lastModified: myFile.lastModified,
                //     size: myFile.size,
                //     type: myFile.type,
                //     path: imageurl,
                // }
                // dispatch(scanface(JSON.stringify(fileObject)))
                console.log(myFile, imageurl, '/......')
                handleUpload(myFile, imageurl)
                setTimeout(() => {

                    // openCamera(false);
                }, 200)
            })
    }



    const setfacMode = () => {

        setFacingMode(false)

        setTimeout(() => {

            setFacingMode(facingMode == 'back' ? 'front' : 'back')
        }, 300)
    }

    return (
        <>
            {/* <Webcam
                audio={false}
                height={400}
                width={400}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
            /> */}
            <div className="cameraopen_div">
                {facingMode == 'back' ?
                    <Camera
                        // onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                        onTakePhotoAnimationDone={(dataUri) => { handleTakePhotoAnimationDone(dataUri); }}
                        onCameraError={(error) => { alert(error) }}
                        idealFacingMode={FACING_MODES.ENVIRONMENT}
                        // idealFacingMode={ FACING_MODES.ENVIRONMENT }
                        idealResolution={{ width: 500, height: 500 }}
                        imageType={IMAGE_TYPES.JPG}
                        imageCompression={0.97}
                        // isMaxResolution = {true}
                        isImageMirror={false}
                        isSilentMode={false}
                        isDisplayStartCameraError={true}
                        isFullscreen={false}
                        sizeFactor={1}
                    /> : <Camera
                        // onTakePhoto = { (dataUri) => { handleTakePhoto(dataUri); } }
                        onTakePhotoAnimationDone={(dataUri) => { handleTakePhotoAnimationDone(dataUri); }}
                        onCameraError={(error) => { alert(error) }}
                        idealFacingMode={FACING_MODES.USER}
                        // idealFacingMode={ FACING_MODES.ENVIRONMENT }
                        idealResolution={{ width: 600, height: 600 }}
                        imageType={IMAGE_TYPES.JPG}
                        imageCompression={0.97}
                        // isMaxResolution = {true}
                        isImageMirror={false}
                        isSilentMode={false}
                        isDisplayStartCameraError={true}
                        isFullscreen={false}
                        sizeFactor={1}
                    />
                }
            </div>
            {/* <button onClick={() => { setfacMode() }}>flip camera</button> */}
            {/* <button onClick={() => setFacingMode(FACING_MODES.USER)}>Front</button> */}
        </>
    );
};
